/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automatic_Save_Restore_Point_CreatedInputs */



/**
* | output |
* | --- |
* | "Restore point created successfully" |
*
* @param {Automatic_Save_Restore_Point_CreatedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const automatic_save_restore_point_created = /** @type {((inputs?: Automatic_Save_Restore_Point_CreatedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automatic_Save_Restore_Point_CreatedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Point de restauration créé avec succès")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wiederherstellungspunkt erfolgreich erstellt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Punto di ripristino creato correttamente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Точка восстановления успешно создана.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Punto de restauración creado exitosamente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("还原点创建成功")
	if (locale === "ja") return /** @type {LocalizedString} */ ("復元ポイントが正常に作成されました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पुनर्स्थापना बिंदु सफलतापूर्वक बनाया गया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ponto de restauração criado com sucesso")
	return /** @type {LocalizedString} */ ("Restore point created successfully")
});